import React, { FC } from 'react';
import { DialogContent, Button, DialogActions, DialogTitle, Dialog, Typography, Alert } from '@mui/material';

interface Props {
  open: boolean;
  title?: string;
  okBtnTitle?: string;
  content: string;
  onClose: () => void;
}

export const InfoModal: FC<Props> = ({ open, title, okBtnTitle = 'OK', content, onClose }) => {
  const handleClose = (event, reason: string) => {
    if (reason && reason === 'backdropClick') return;

    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Typography variant="h5">{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning">
          <Typography variant="body1">{content}</Typography>
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" data-testid={`${okBtnTitle}-ok-btn`}>
          {okBtnTitle}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
